import React from "react";
import { Spinner } from "reactstrap";

export default function Loader() {
  return <Spinner size={"sm"} style={{ borderWidth: "2px", color: "inherit" }} />;
}
